export const formatDate = (date: string) => {
    const d = new Date(date);
    const now = new Date();

    const diffMs = now.getTime() - d.getTime();
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHour = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHour / 24);

    if (diffSec < 60) return 'только что';
    if (diffMin < 60) return `${diffMin} мин назад`;
    if (diffHour < 24) return `${diffHour} ч назад`;
    if (diffDay < 7) return `${diffDay} дн назад`;

    const day = d.getDate();
    const month = d.toLocaleString('ru-RU', { month: 'long' });
    const year = d.getFullYear();

    const isCurrentYear = year === now.getFullYear();

    if (isCurrentYear) {
        return `${day} ${month}`;
    }

    return `${day} ${month} ${year}`;
};